import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const FaqPage = () => (
  <div className="min-h-screen bg-[#040c0e] text-cyan-100 px-6 py-10">
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="inline-flex items-center gap-1.5 text-[12px] text-cyan-400 hover:text-cyan-200 mb-6">
        <ArrowLeft className="w-3.5 h-3.5" /> Back to map
      </Link>
      <h1 className="text-3xl font-semibold text-cyan-50 mb-4">FAQ — How OutbreakMap works</h1>
      <p className="text-cyan-400 text-[14px] mb-8">A signal is not a case. Here's the editorial logic.</p>
      <div className="space-y-5 text-[14px] leading-relaxed">
        <div><h3 className="text-cyan-50 font-semibold mb-1">What is a “signal”?</h3><p>A signal is any publicly reported mention of disease activity — official, emerging, or unverified chatter.</p></div>
        <div><h3 className="text-cyan-50 font-semibold mb-1">How often does the map update?</h3><p>Signals are refreshed automatically on Cloudflare every hour. There is no manual refresh control.</p></div>
        <div><h3 className="text-cyan-50 font-semibold mb-1">Which diseases are tracked?</h3><p>We currently track 12+ priority diseases including Hantavirus, COVID-19, Ebola, Marburg, Mpox, Dengue, Zika, H5N1, Cholera, Measles, Nipah and Lassa fever.</p></div>
      </div>
    </div>
  </div>
);
export default FaqPage;
